import { NavLink } from "react-router-dom";
import {
  BookHeart,
  Flame,
  Home,
  ListChecks,
  NotebookText,
  User,
} from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/dashboard", label: "Accueil", Icon: Home },
  { to: "/menu", label: "Menu", Icon: NotebookText },
  { to: "/recipe-book", label: "Mes recettes", Icon: BookHeart },
  { to: "/shopping", label: "Courses", Icon: ListChecks },
  { to: "/cooking", label: "Cuisine", Icon: Flame },
  { to: "/profile", label: "Moi", Icon: User },
] as const;

/**
 * Persistent bottom tab bar — appears on every authed page except the
 * full-screen Cooking Mode flow (which mounts its own controls).
 */
export function BottomTabBar() {
  return (
    <nav
      aria-label="Navigation principale"
      className="flex shrink-0 items-center justify-around border-t border-hair bg-background pb-[calc(28px+env(safe-area-inset-bottom))] pt-3"
    >
      {TABS.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/dashboard"}
          className={({ isActive }) =>
            cn(
              "flex flex-col items-center gap-1 transition-colors",
              isActive ? "text-foreground" : "text-ink-30",
            )
          }
        >
          {({ isActive }) => (
            <>
              <Icon
                aria-hidden
                className="size-5"
                strokeWidth={isActive ? 1.75 : 1.25}
              />
              <span
                className={cn(
                  "text-[10px] tracking-[0.08em]",
                  isActive ? "font-semibold" : "font-normal",
                )}
              >
                {label}
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
